import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer } from '@angular/core'

@Component({
  selector: 'text-search',
  template: `
    <input
      #input
      [type]="inputType"
      [ngClass]="inputClass"
      [(ngModel)]="value"
      (keyup)="onKeyup($event)"
    />
  `,
  styles: [require('./text-search.component.sass')]
})

export class TextSearchComponent {
  @ViewChild('input') inputElRef: ElementRef

  @Input() value: string = ''
  @Input() inputClass: string = ''
  @Input() inputType: string = 'text'
  @Input() inputMin: number = 2
  @Input() inputDelay: number = 500

  @Output('onChange') onChangeEmitter = new EventEmitter<Object>()
  @Output('onClear') onClearEmitter = new EventEmitter<Object>()
  @Output('onKeyup') onKeyupEmitter = new EventEmitter<Object>()

  private debounceTimeout: any = null

  constructor(private renderer: Renderer) {}

  setFocus() {
    this.renderer.invokeElementMethod(this.inputElRef.nativeElement, 'focus')
  }

  private onKeyup(event) {
    if(this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
    this.debounceTimeout = setTimeout(() => {
      if (this.value == null || this.value.length == 0) {
        this.onClearEmitter.emit(event)
        this.onChangeEmitter.emit({ value: null })
      } else if (this.value.length >= this.inputMin) {
        this.onChangeEmitter.emit({ value: this.value })
      }
      this.debounceTimeout = null
    }, this.inputDelay)
    this.onKeyupEmitter.emit(event)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/search/text-search.component.ts